export enum CampaignsActionType {
    START_REQUEST = 'START_REQUEST',
    END_REQUEST = 'END_REQUEST',
    TOGGLE_CREATE_AUDIENCE_MODAL = 'TOGGLE_CREATE_AUDIENCE_MODAL',
    TOGGLE_CREATE_PERK_MODAL = 'TOGGLE_CREATE_PERK_MODAL',
    TOGGLE_CREATE_VOUCHER_MODAL = 'TOGGLE_CREATE_VOUCHER_MODAL',
    UPDATE_CAMPAIGN_ITEM = 'UPDATE_CAMPAIGN_ITEM',
    ADD_CAMPAIGN_ITEM = 'ADD_CAMPAIGN_ITEM',
    CRUD_CAMPAIGNS_ABORT = 'CRUD_CAMPAIGNS_ABORT',
    CRUD_CAMPAIGNS_SUCCESS = 'CRUD_CAMPAIGNs_SUCCESS',
    ADD_EMPTY_CAMPAIGN = 'ADD_EMPTY_CAMPAIGN',
    UPDATE_CAMPAIGN_EFFECT_TARGET = 'UPDATE_CAMPAIGN_EFFECT_TARGET',
    UPDATE_CAMPAIGN_CONDITION_VARIANT_VALUE = 'UPDATE_CAMPAIGN_CONDITION_VARIANT_VALUE',
    CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS',
    LOAD_CAMPAIGN_SUCCESS = 'LOAD_CAMPAIGN_SUCCESS',
    DISCARD_CAMPAIGN_PERK_CREATION = 'DISCARD_CAMPAIGN_PERK_CREATION',
    DISCARD_CAMPAIGN_AUDIENCE_CREATION = 'DISCARD_CAMPAIGN_AUDIENCE_CREATION',
    DISCARD_CAMPAIGN_VOUCHER_CREATION = 'DISCARD_CAMPAIGN_VOUCHER_CREATION',
    CLOSE_CAMPAIGN_MODALS = 'CLOSE_MODALS',
    CLOSE_CAMPAIGN_DISCARD_MODALS = 'CLOSE_DISCARD_MODALS',
    DELETE_CAMPAIGN_ITEM = 'DELETE_CAMPAIGN_ITEM'
}
